export default __webpack_public_path__ + "static/expense-claims-84af45a227fccb31d7d405c7fe84c0ba.png";